import { Component, HostBinding, Input } from '@angular/core';

enum Margin {
  NONE = '0px',
  XXXSMALL = '4px',
  XXSMALL = '8px',
  XSMALL = '12px',
  SMALL = '16px',
  MID = '24px',
  LARGE = '32px',
  XLARGE = '48px',
  XXLARGE = '64px',
  XXXLARGE = '72px',
  XXXXLARGE = '96px',
}

@Component({
  selector: 'fl-base',
  template: ``,
})
export class BaseComponent {
  Margin = Margin;

  @HostBinding('style.margin-right')
  @Input()
  marginRight = Margin.NONE;

  @HostBinding('style.margin-bottom')
  @Input()
  marginBottom = Margin.NONE;
}



// WEBPACK FOOTER //
// ./src/@freelancer/ui/base/base.component.ts